"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StoreName;
(function (StoreName) {
    StoreName["HumorPageStore"] = "HumorPageStore";
    StoreName["BottomCompactStore"] = "BottomCompactStore";
    StoreName["CommentDetailStore"] = "CommentDetailStore";
    StoreName["CommentInputStore"] = "CommentInputStore";
    StoreName["CommentListHumorStore"] = "CommentListHumorStore";
    StoreName["CommentListV1Store"] = "CommentListV1Store";
    StoreName["CommentListV2Store"] = "CommentListV2Store";
    StoreName["CommentActionsStore"] = "CommentActionsStore";
    StoreName["FollowStore"] = "FollowStore";
    StoreName["RelatedNewsStore"] = "RelatedNewsStore";
    StoreName["RelatedTopicStore"] = "RelatedTopicStore";
    StoreName["TreasureBoxStore"] = "TreasureBoxStore";
    StoreName["CommentLikeStore"] = "CommentLikeStore";
    StoreName["EnviStore"] = "EnviStore";
    StoreName["UserStore"] = "UserStore";
    StoreName["HumorChannelStore"] = "HumorChannelStore";
    StoreName["UploadStore"] = "UploadStore";
    StoreName["ProductStore"] = "ProductStore";
    StoreName["HumorShareListStore"] = "HumorShareListStore";
    StoreName["AdsFooterStore"] = "AdsFooterStore";
    StoreName["AdsMiddleStore"] = "AdsMiddleStore";
    StoreName["HumorChannelInputStore"] = "HumorChannelInputStore";
})(StoreName = exports.StoreName || (exports.StoreName = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdG9yZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLElBQWEsU0F1Qlo7QUF2QkQsV0FBYSxTQUFTO0lBQ2xCLDhDQUFpQyxDQUFBO0lBQ2pDLHNEQUF5QyxDQUFBO0lBQ3pDLHNEQUF5QyxDQUFBO0lBQ3pDLG9EQUF1QyxDQUFBO0lBQ3ZDLDREQUErQyxDQUFBO0lBQy9DLHNEQUF5QyxDQUFBO0lBQ3pDLHNEQUF5QyxDQUFBO0lBQ3pDLHdEQUEyQyxDQUFBO0lBQzNDLHdDQUEyQixDQUFBO0lBQzNCLGtEQUFxQyxDQUFBO0lBQ3JDLG9EQUF1QyxDQUFBO0lBQ3ZDLGtEQUFxQyxDQUFBO0lBQ3JDLGtEQUFvQyxDQUFBO0lBQ3BDLG9DQUF1QixDQUFBO0lBQ3ZCLG9DQUF1QixDQUFBO0lBQ3ZCLG9EQUF1QyxDQUFBO0lBQ3ZDLHdDQUEyQixDQUFBO0lBQzNCLDBDQUE2QixDQUFBO0lBQzdCLHdEQUEyQyxDQUFBO0lBQzNDLDhDQUFpQyxDQUFBO0lBQ2pDLDhDQUFpQyxDQUFBO0lBQ2pDLDhEQUFpRCxDQUFBO0FBQ3JELENBQUMsRUF2QlksU0FBUyxHQUFULGlCQUFTLEtBQVQsaUJBQVMsUUF1QnJCIn0=